var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningWithCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#F6AE2D",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6667 30.0003C32.6667 29.2643 33.264 28.667 34 28.667C34.736 28.667 35.3333 29.2643 35.3333 30.0003V35.3337C35.3333 36.0697 34.736 36.667 34 36.667C33.264 36.667 32.6667 36.0697 32.6667 35.3337V30.0003ZM32.6667 39.3337C32.6667 38.5977 33.264 38.0003 34 38.0003C34.736 38.0003 35.3333 38.5977 35.3333 39.3337C35.3333 40.0697 34.736 40.667 34 40.667C33.264 40.667 32.6667 40.0697 32.6667 39.3337ZM45.8196 42.471C45.5143 43.011 44.9196 43.3337 44.2289 43.3337H23.7703C23.0796 43.3337 22.4849 43.011 22.1809 42.471C22.0369 42.2177 21.8476 41.7017 22.2036 41.115L32.4316 24.1577C33.0543 23.1257 34.9449 23.1257 35.5676 24.1577L45.7969 41.115C46.1516 41.7017 45.9636 42.2177 45.8196 42.471ZM48.0809 39.7377L37.8516 22.779C37.0529 21.4563 35.6129 20.667 33.9996 20.667C32.3863 20.667 30.9463 21.4563 30.1489 22.779L19.9196 39.7377C19.1609 40.995 19.1383 42.507 19.8583 43.7817C20.6303 45.151 22.1303 46.0003 23.7703 46.0003H44.2289C45.8703 46.0003 47.3689 45.151 48.1423 43.7817C48.8623 42.507 48.8396 40.995 48.0809 39.7377Z",
    fill: "#F6AE2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWithCircle);
export default __webpack_public_path__ + "static/media/WarningWithCircle.133cd7c3d60abd7bf41d5001363a094f.svg";
export { ForwardRef as ReactComponent };